module.exports = __webpack_public_path__ + "static/img/SSDHighlightVideo_GillesDesroches_Still.8de796b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/thumbnails/SSDHighlightVideo_GillesDesroches_Still.jpg
// module id = H2rb
// module chunks = 0